/**
 * The product's official naming — Timo's wording, and the only place the
 * frontend spells it out.
 *
 * `NOVA` is what the product is called in running text; the expansion is a
 * subtitle used once per surface (shell brand, login card), never repeated as
 * a substitute for the name. The tagline is the one-line "what is this?".
 *
 * The ampersand lives here as a plain character: rendering these through JSX
 * expressions (`{PRODUCT_EXPANSION}`) escapes correctly on its own, so no
 * markup entity is ever needed at the call site. `index.html` carries the same
 * strings with `&amp;`, since that one is parsed as HTML.
 */

/** What the product is called. Use this in running text. */
export const PRODUCT_NAME = "NOVA";

/** What the name stands for. A subtitle, not a replacement for the name. */
export const PRODUCT_EXPANSION = "Norican Operations Visibility & Assurance";

/** The one-line description of what NOVA does. */
export const PRODUCT_TAGLINE = "Unified IT, network and security operations.";
